import { render, staticRenderFns } from "./shipping.vue?vue&type=template&id=3747f336"
import script from "./shipping.vue?vue&type=script&lang=js"
export * from "./shipping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports